module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-194.273b6d6b.svg";